import type { IamStaffProfile, Membership } from '@/api/types'

export const mockStaffs: IamStaffProfile[] = [
  {
    id: 'u-boss-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '张总',
    phone: '13800000001',
    email: 'zhangzong@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-01-15T08:00:00Z',
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2025-08-20T10:30:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'u-principal-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '李校长',
    phone: '13800000002',
    email: 'lixiaozhang@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-02-01T08:00:00Z',
    createdAt: '2024-02-01T08:00:00Z',
    updatedAt: '2025-07-15T09:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'u-consultant-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '王顾问',
    phone: '13800000003',
    email: 'wangguwen@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-03-10T08:00:00Z',
    createdAt: '2024-03-10T08:00:00Z',
    updatedAt: '2025-06-01T14:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'u-teacher-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '赵老师',
    phone: '13800000004',
    email: 'zhaolaoshi@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-04-05T08:00:00Z',
    createdAt: '2024-04-05T08:00:00Z',
    updatedAt: '2025-05-20T16:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'u-finance-001',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '钱财务',
    phone: '13800000005',
    email: 'qiancaiwu@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-05-15T08:00:00Z',
    createdAt: '2024-05-15T08:00:00Z',
    updatedAt: '2025-08-01T11:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'u-auditor-001',
    brandId: 'b-001',
    campusId: 'c-001',
    name: '孙审计',
    phone: '13800000006',
    email: 'sunshenji@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-06-20T08:00:00Z',
    createdAt: '2024-06-20T08:00:00Z',
    updatedAt: '2025-07-10T10:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'u-teacher-002',
    brandId: 'b-001',
    campusId: 'c-002',
    name: '周老师',
    phone: '13800000007',
    email: 'zhoulaoshi@guojiangedu.com',
    avatar: '',
    status: 'ACTIVE',
    hiredAt: '2024-07-01T08:00:00Z',
    createdAt: '2024-07-01T08:00:00Z',
    updatedAt: '2025-06-15T09:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'u-consultant-002',
    brandId: 'b-001',
    campusId: 'c-003',
    name: '吴顾问',
    phone: '13800000008',
    email: 'wuguwen@guojiangedu.com',
    avatar: '',
    status: 'PENDING_ACTIVATION',
    hiredAt: '2025-09-01T08:00:00Z',
    createdAt: '2025-09-01T08:00:00Z',
    updatedAt: '2025-09-01T08:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
]

export const mockMemberships: Membership[] = [
  {
    id: 'm-001',
    staffId: 'u-boss-001',
    staffName: '张总',
    roleId: 'r-boss',
    roleName: '老板',
    campusId: 'c-001',
    campusName: '总部校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-01-15T08:00:00Z',
    grantedBy: 'system',
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
    createdBy: 'system',
    updatedBy: 'system',
  },
  {
    id: 'm-002',
    staffId: 'u-principal-001',
    staffName: '李校长',
    roleId: 'r-principal',
    roleName: '校长',
    campusId: 'c-001',
    campusName: '总部校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-02-01T08:00:00Z',
    grantedBy: 'u-boss-001',
    createdAt: '2024-02-01T08:00:00Z',
    updatedAt: '2024-02-01T08:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'm-003',
    staffId: 'u-consultant-001',
    staffName: '王顾问',
    roleId: 'r-consultant',
    roleName: '顾问',
    campusId: 'c-001',
    campusName: '总部校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-03-10T08:00:00Z',
    grantedBy: 'u-principal-001',
    createdAt: '2024-03-10T08:00:00Z',
    updatedAt: '2024-03-10T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'm-004',
    staffId: 'u-teacher-001',
    staffName: '赵老师',
    roleId: 'r-teacher',
    roleName: '教务老师',
    campusId: 'c-001',
    campusName: '总部校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-04-05T08:00:00Z',
    grantedBy: 'u-principal-001',
    createdAt: '2024-04-05T08:00:00Z',
    updatedAt: '2024-04-05T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
  {
    id: 'm-005',
    staffId: 'u-finance-001',
    staffName: '钱财务',
    roleId: 'r-finance',
    roleName: '财务',
    campusId: 'c-002',
    campusName: '朝阳校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-05-15T08:00:00Z',
    grantedBy: 'u-boss-001',
    createdAt: '2024-05-15T08:00:00Z',
    updatedAt: '2024-05-15T08:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'm-006',
    staffId: 'u-auditor-001',
    staffName: '孙审计',
    roleId: 'r-frontdesk',
    roleName: '前台',
    campusId: 'c-001',
    campusName: '总部校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-06-20T08:00:00Z',
    grantedBy: 'u-boss-001',
    createdAt: '2024-06-20T08:00:00Z',
    updatedAt: '2024-06-20T08:00:00Z',
    createdBy: 'u-boss-001',
    updatedBy: 'u-boss-001',
  },
  {
    id: 'm-007',
    staffId: 'u-teacher-002',
    staffName: '周老师',
    roleId: 'r-teacher',
    roleName: '教务老师',
    campusId: 'c-002',
    campusName: '朝阳校区',
    brandId: 'b-001',
    status: 'ACTIVE',
    grantedAt: '2024-07-01T08:00:00Z',
    grantedBy: 'u-principal-001',
    createdAt: '2024-07-01T08:00:00Z',
    updatedAt: '2024-07-01T08:00:00Z',
    createdBy: 'u-principal-001',
    updatedBy: 'u-principal-001',
  },
]
